import React, { Component, useEffect, useState, useRef } from "react";
import { Modal, Button, Dropdown } from "react-bootstrap";
import { getAlert } from "../Services/appAlerts";
import { getCurrentUser } from "../app/store/auth";
import { useDispatch, useSelector } from "react-redux";
import { addAppNewMessage, appMessageAdded, getAddedMessageStatus, getLocalDocUploadSasUrl } from "../app/store/messages";
import { uploadFileToBlob } from "../Services/blobUploadService";

const AddNewMessage = (props) => {
  const { addMsgShowHide, handleAddMsgModalShowHide, runningApplication } = props;

  const [documents, setDocuments] = useState([]);
  const [msg, setMsg] = useState("");
  const [btnSaveProcess, setBtnSaveProcess] = useState(false);
  const [isDragging, setIsDragging] = useState(false);

  const addedMessageStatusSelector = useSelector(getAddedMessageStatus);
  const localDocUploadSasUrlSelector = useSelector(getLocalDocUploadSasUrl);

  const currentUser = getCurrentUser();
  const dispatch = useDispatch();
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!addMsgShowHide) {
      setMsg("");
      setDocuments([]);
    }
  }, [addMsgShowHide])

  const onFileChange = async (event) => {
    const docs = [...documents];
    for (const file of event.target.files) {
      var doc = {
        name: file.name,
        type: file.type,
        size: file.size,
        file: file,
      };
      docs.push(doc);
    }
    setDocuments(docs);
  };

  const handleFileRemove = (item) => {
    const updatedDocuments = documents.filter((doc) => doc !== item);
    setDocuments(updatedDocuments);
  };

  // Drag & Drop Handlers
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => {
    setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    const files = Array.from(e.dataTransfer.files);
    const docs = files.map(file => ({
      name: file.name,
      type: file.type,
      size: (file.size / 1024).toFixed(2),
      file: file,
    }));
    setDocuments(prev => [...prev, ...docs]);
  };

  const handleMessageChange = ({ currentTarget }) => {
    setMsg(currentTarget.value);
  };

  const doSubmit = () => {
    setBtnSaveProcess(true);
    let usrId = currentUser.id;
    if (currentUser.linkUser)
      usrId = currentUser.linkUser;
    const frmData = new FormData();
    frmData.append("workflowTask", JSON.stringify(runningApplication[0]));
    frmData.append("message", msg);
    frmData.append("userId", usrId);
    // documents.map((file, key) =>
    //   frmData.append("files[" + key + "]", file.file)
    // );
    frmData.append("files", JSON.stringify(documents.map(x => ({ name: x.name, type: x.type, size: x.size }))));
    dispatch(addAppNewMessage(frmData));
  };

  useEffect(() => {
    if (addedMessageStatusSelector) {
      getAlert("", "Message Sent Successfully to Review Officer", "success");
      dispatch(appMessageAdded(false));
      setBtnSaveProcess(false);
      handleAddMsgModalShowHide("save");
    }
  }, [addedMessageStatusSelector])

  useEffect(() => {
    if (localDocUploadSasUrlSelector) {
      console.log("Received SAS URL for local document upload:", localDocUploadSasUrlSelector);
      // You can now use this SAS URL to upload the document directly to Azure Blob Storage
      // For example, you could call a function like uploadFileToBlob(file, localDocUploadSasUrlSelector)
      documents.map((file, key) =>
        uploadFileToBlob(file.file, localDocUploadSasUrlSelector, (progress) => {
          console.log(`Upload progress: ${progress}%`);
        })
      )
    }
  }, [localDocUploadSasUrlSelector]);



  return (
    <Modal show={addMsgShowHide} size="xl">
      <Modal.Header closeButton onHide={() => handleAddMsgModalShowHide("")}>
        <Modal.Title>Add Message</Modal.Title>
      </Modal.Header>
      <Modal.Body className="border">
        <div className="row">

          {/* Drop Zone */}
          <div className="col-md-12">
            <div
              className={`drop-zone w-100 p-4 mb-3 text-center border rounded ${isDragging ? "bg-light" : ""}`}
              onDragOver={handleDragOver}
              onDragLeave={handleDragLeave}
              onDrop={handleDrop}
              onClick={() => fileInputRef.current.click()}
              style={{
                border: "2px dotted #ccc",
                borderRadius: "8px",
                padding: "30px",
                textAlign: "center",
                background: isDragging ? "#f0f8ff" : "#fafafa",
                cursor: "pointer",
                transition: "background 0.2s ease",
              }}
            >
              <i className="fa fa-cloud-upload fa-2x mb-2"></i>
              <p className="mb-0">
                {isDragging ? "Drop files here..." : "Drag & drop files here, or click to select"}
              </p>
            </div>
          </div>

          {documents.length > 0 && (
            <div className="file-preview w-100 mb-3">
              {documents.map((file, index) => (
                <div key={index} className="file-preview-item ml-2">
                  <span>{file.name}</span>
                  <span
                    className="file-size"
                    style={{
                      backgroundColor: "#f0f0f0",
                      marginLeft: "10px",
                      padding: "2px 5px",
                      borderRadius: "5px",
                    }}
                  >
                    {file.size} KB
                  </span>
                  <button
                    className="btn btn-sm btn-link"
                    onClick={() => handleFileRemove(file)}
                  >
                    <i className="fa fa-times text-black"></i>
                  </button>
                </div>
              ))}
            </div>
          )}
          <div className="col-md-12">
            <div className="form-group">
              <label htmlFor="msg" className="form-control-label">
                Message
              </label>
              <textarea
                name="msg"
                id="msg"
                cols="2"
                rows="2"
                className="form-control"
                value={msg}
                onChange={handleMessageChange}
              ></textarea>
            </div>
          </div>
          <div className="col-12 text-center mt-3 d-flex justify-content-center">
            {/* <Button
              variant="outline-dark"
              size="sm"
              onClick={() => fileInputRef.current.click()}
            >
              <i className="fa fa-paperclip mr-2" ></i>
              Add
            </Button> */}

            <Button variant="outline-default" size="sm" onClick={doSubmit}>
              <i className="fa fa-paper-plane-o mr-2" ></i>
              Send
            </Button>
          </div>
          <input
            type="file"
            ref={fileInputRef}
            onChange={onFileChange}
            aria-label="Upload files"
            multiple
            style={{ display: "none" }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
      </Modal.Footer>
    </Modal>
  );
}

export default AddNewMessage;
